export default {
  getRestaurantMeals: "GET_RESTAURANT_MEALS",
  getRestaurantMealsSuccess: "GET_RESTAURANT_MEALS_SUCCESS",
  getRestaurantMealsFailed: "GET_RESTAURANT_MEALS_FAILED",
}